import { Popup } from '@paywithextend/components'
import React, { ReactElement, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import CancelSubscriptionInfo from 'src/components/CancelSubscription/CancelSubscriptionInfo'
import CancelSubscriptionSubmission from 'src/components/CancelSubscription/CancelSubscriptionSubmission'
import { connectedReplace } from 'src/navigation/Lnk'
import {
  CANCEL_SUBSCRIPTION_ROUTE,
  organizationInfoUrl,
} from 'src/navigation/urls'
import {
  useCancelSubscription,
  useQueryOrganizationSaasTier,
} from 'src/queries/organizations/saas.queries'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectUserExplicitOrganizationListModelFromState } from 'src/redux/selectors/data/organizations.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { css } from 'styled-components'

export default function CancelSubscriptionPage(): ReactElement {
  const dispatch = useDispatch()
  const location = useSelector(selectLocationFromState)
  const id = useSelector(selectUserListModelFromState)?.organizationId

  const { mutate: cancelSubscription } = useCancelSubscription()
  const orgId = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )?.id

  const { data: currentPlan } = useQueryOrganizationSaasTier({
    orgId: orgId || '',
    enabled: !!orgId,
  })

  type CancelSubscriptionScreen = 'info' | 'submission'
  const [currentScreen, setCurrentScreen] =
    useState<CancelSubscriptionScreen>('info')

  const leaveCancelSubscriptionModal = (): void => {
    if (id) {
      dispatch(connectedReplace(organizationInfoUrl(id)))
    }
  }

  const currentScreenComponent = useMemo(() => {
    switch (currentScreen) {
      case 'info':
        return (
          <CancelSubscriptionInfo
            onConfirm={(): void => setCurrentScreen('submission')}
            onCancel={leaveCancelSubscriptionModal}
          />
        )
      case 'submission':
        return (
          <CancelSubscriptionSubmission
            onConfirm={(): void => {
              leaveCancelSubscriptionModal()
              cancelSubscription({
                orgId: orgId || '',
                tier: currentPlan?.tier,
                body: {
                  intention: 'cancel_subscription',
                },
              })
            }}
            onCancel={leaveCancelSubscriptionModal}
          />
        )
      default:
        return (
          <CancelSubscriptionInfo
            onConfirm={(): void => setCurrentScreen('submission')}
            onCancel={leaveCancelSubscriptionModal}
          />
        )
    }
  }, [currentScreen])

  useEffect(() => {
    if (id) {
      matchPath(location.pathname, CANCEL_SUBSCRIPTION_ROUTE(id))
    }
  }, [currentScreen])

  useEffect(() => {
    if (id) {
      matchPath(location.pathname, CANCEL_SUBSCRIPTION_ROUTE(id))
    }
  }, [location])
  return (
    <Popup
      showCloseButton
      onClickClose={leaveCancelSubscriptionModal}
      css={css`
        overflow: clip;
      `}
    >
      {currentScreenComponent}
    </Popup>
  )
}
